<template>
  <div v-if="faq" class="pt260 container-fluid">
    <faq-header :breadcrumb="faq"></faq-header>
    <div>
      <a @click="goBack" class="card backButton" >
        <div class="back card-body d-flex flex-column justify-content-center">
          <h5 class="backH5">戻る</h5>
        </div>
      </a>
    </div>
    <div class="contents">
      <h2>{{ faq.QUESTION }}</h2>
      <div class="mt-4 text-break" >
        <h4 class="border-bottom pb-4">回答</h4>
        <div class="mt-4 text-break" v-html="faq.ANSWER"></div>
        <p v-if="faq.URL" class="mt-4">
            <span v-for="(url,idx) in faq.URL.split('\n')" :key="`url_${idx}`" >
              <a target="_blank" :href="url">{{ url }}</a><br />
            </span>
        </p>
      </div>
    </div>


    <div id="internal" v-if="faq.FAQ_CD" class="card bg-light mt-4" >
      <div class="card-body">
        <h5 class="card-title text-primary">外部非公開情報</h5>
        <div class="card-text">

          <div>
            <div class="row">
              <div class="col-12 ">
                  <div class="title">FAQコード:</div>
                  <div class="content">{{ faq.FAQ_CD }}</div>
              </div>
              <div class="col-4 mt-2">
                  <span class="title">担当部:</span>
                  <div class="content">{{ faq.SOSIKI_LEVEL_NO1_NM }}</div>
              </div>
              <div class="col-4">
                <div class="title">担当課:</div>
                <div class="content">{{ faq.SOSIKI_LEVEL_NO2_NM }}</div>
              </div>
              <div class="col-4">
                <div class="title">担当係:</div>
                <div class="content">{{ faq.SOSIKI_LEVEL_NO3_NM }}</div>
              </div>
              <div class="col-4 mt-2">
                <div class="title">内線:</div>
                <div class="content">{{ faq.BIKO2 }}</div>
              </div>
              <div class="col-4">
                <div class="title">外線:</div>
                <div class="content">{{ faq.BIKO3 }}</div>
              </div>
              <div class="col-12 mt-2">
                <div class="title">備考:</div>
                <div class="content" v-html="faq.BIKO1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

/*
* Import libs and componnents
*/
import Loading from 'vue-loading-overlay';
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
  /*
  * Name of component
  */
  name: "PT260FAQContentParts",
  props:{
    ptInitData: {
      type: Object,
      default: null,
    }
  },
  /*
  * Get data from parent component
  */
  components:
      {
        Loading,
        FaqHeader: () => import('./components/FaqHeader.vue')
      },
  data() {
    return {
      faq: null
    }
  },
  mounted() {
    // var _this = this;
    // _this.site = _this.$router.history.current.fullPath.split("/")[1];
    // // eslint-disable-next-line
    if (this.ptInitData){
      this.faq = this.ptInitData.faq;

      if(window.opener){
        const param = {
          'faq' : this.faq
        }
        window.opener.postMessage(param,'*')
      }
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    onCategoryClick(categoryNo){
      this.$router.push({ name: SiteConstants.PG010, query: { pageNo: 51, categoryNo : categoryNo }});
    },
  },
}
</script>

